var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"CollageDiff"}},[_c('div',{attrs:{"id":"cuts"}},_vm._l((_vm.sortedCuts),function(item){return _c('div',{key:item.id},[_c('div',{staticClass:"cutDiff"},[_c('p'),_c('div',{staticClass:"covered",style:({
          backgroundImage: ("url(" + _vm.flatImgUrl + ")"),
          backgroundPosition: '-'+item.x+'px '+'-'+item.y+'px',
          backgroundRepeat:'no-repeat',
          height: item.h+'px',
          width: item.w+'px'
        })}),_c('div',{staticClass:"cover",style:({
          backgroundImage: ("url('http://dept-collage.dcfvg.fr/porto/crops/" + (item.id) + ".jpg')"),
          backgroundRepeat:'no-repeat',
          height: item.h+'px',
          width: item.w+'px'
        })}),_c('div',{staticClass:"caption",style:({ width: item.w+'px'})},[_c('p',[_c('span',{staticClass:"index"},[_vm._v(_vm._s(( _vm.state.cuts.findIndex(function (e) { return e.id == item.id; } )+1 )))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.class))]),_vm._v(" "+_vm._s(item.id))])])])])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }